﻿import lightbox from "../node_modules/lightbox2/src/js/lightbox.js";

lightbox.option({
    'wrapAround': true,
    'disableScrolling': true,
    'alwaysShowNavOnTouchDevices': true
});

